import { render, staticRenderFns } from "./PartnerSelector.vue?vue&type=template&id=4452bfdc&scoped=true"
import script from "./PartnerSelector.vue?vue&type=script&lang=js"
export * from "./PartnerSelector.vue?vue&type=script&lang=js"
import style0 from "./PartnerSelector.vue?vue&type=style&index=0&id=4452bfdc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4452bfdc",
  null
  
)

export default component.exports